import React from "react";
import "./App.css";
import Footer from "./Components/Footer";
import { BrowserRouter as Router } from "react-router-dom";
import BaseRouter from "./Routes/routes";
import "./resources/images/css/Navigation.css";
import "./resources/images/css/teamstyle.css";
import "./resources/images/css/MainStyle.css";

function App() {
  return (
    <div className="body">
      <Router>
        <BaseRouter />
      </Router>
      <Footer />
    </div>
  );
}

export default App;
